import React, { useEffect } from 'react'
import "./SaveRequirement.scss"
import { useRef,useContext,useState } from 'react';
import { useLocation,useNavigate, useNavigationType, useOutletContext } from 'react-router-dom'
import DashboardHeader from '../../../components/dashboardheader/DashboardHeader';
import ContactSearchSelectAdd from '../../../components/contactsearchselectadd/ContactSearchSelectAdd';
import { AuthContext } from '../../../context/AuthContext';
import Comp_TransactionType from '../../../components/datacontrols/controlTransactiontype';
import Comp_PropertyType from '../../../components/datacontrols/controlPropertytype';
import Comp_Colonies from '../../../components/datacontrols/controlColony';
import Comp_GeneralFeatures from '../../../components/datacontrols/controlGeneral';
import { use } from 'react';
import encryptedapiRequest from '../../../lib/encryptedapiRequest';
import apiRequest from '../../../lib/apiRequest';
import { consumePendingContact } from '../../../lib/contactReturnStore';
import CancelButton from '../../../components/buttons/cancelbutton/CancelButton';
import { formatToIndianRupees } from '../../../lib/allPurposeFunctions';
import { saveObjectDraft,consumeObjectDraft } from '../../../lib/objectReturnStore';


function SaveRequirement() {
    const { toggleMenu } = useOutletContext();
    const currentUser = useContext(AuthContext).currentUser;

    const location=useLocation();
    const navigate=useNavigate();
    const navType = useNavigationType(); // PUSH | POP | REPLACE
    
    const mode = location.state?.mode;  
    // mode=0 add requirement
    // mode=1
    //  save requirement


    // const requirementObject=location.state?.requirementObject;
    const requirementId=location.state?.requirementId;    
    const userId=location.state?.userId;


    const emptyForm = {
      requirementdate: new Date().toISOString().split('T')[0],
      requirementcontacts:[],
      requirementdetails:'',

      colonies:[],            //tags
      propertytags:[],        //tags
      propertytypes:[],       //tags
      transactiontypes:[],    // tags

      budgetfrom:0,
      budgetto:0,
    };


    

    const tagrefContactSelect=useRef(null);
    // const tagrefTransType=useRef(null);
    // const tagrefPropertyType=useRef(null);
    // const tagrefColonies=useRef(null);
    // const tagrefGeneral=useRef(null);


    const [selectedContacts, setSelectedContacts] = useState([]);

    const [formData, setFormData] = useState(emptyForm);
    


  const [requirementData, setRequirementData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  // ===============================
  // INITIALIZATION FUNCTIONS
  // ===============================

  function restoreDraft() {    
    console.log("restoring draft");

    const draft = consumeObjectDraft();
    if (!draft) return false;

    console.log("restored draft", draft);
    setFormData(draft.formData);

    /// now restore the contact, 
    /// it can be new contact, or it can be contact that was already in the list and now updated

    // const returnContact = consumePendingContact();

    const returnObject = consumePendingContact();
    const returnContact=returnObject?.returnData;



    if (returnContact ){
      // const ContactsUpdated=AddorUpdateContact(draft.selectedContacts, returnContact);
      console.log("contacts updated",returnContact);
      // setSelectedContacts(ContactsUpdated);
      // first restore previous contacts

      // option 1 not working
      // setSelectedContacts(draft.selectedContacts || []);
      // // then add the new contact after React state updates
      // setTimeout(() => {
      //     waitForRefAndAdd(returnContact);
      // }, 0);

      // option 2
      const finalContacts=MergeContacts(returnContact,draft.selectedContacts);
      console.log("final contacts",finalContacts);
      setSelectedContacts(finalContacts);

    }
    else{
      console.log("no pending contact");
      setSelectedContacts(draft.selectedContacts);
    }
    // SetPostobject(draft.postObject);

    return true;
  }

  function MergeContacts(returnContact,draftContacts){
    let mergedContacts = [...(draftContacts || [])];
  
    if (!returnContact) return mergedContacts;
  
    // if (returnContact) {
    //   const index = mergedContacts.findIndex(c => Number(c.id) === Number(returnContact.id));
    //   if (index >= 0) mergedContacts[index] = returnContact; // update existing
    //   else mergedContacts.push(returnContact); // add new
    // }

    const id = Number(returnContact.id);
    const index = mergedContacts.findIndex(c => Number(c.id) === id);

    if (index >= 0) {
          // Merge existing, ensure status is preserved or default to "add"
          mergedContacts[index] = { 
            ...mergedContacts[index], 
            ...returnContact, 
            status: mergedContacts[index].status || "default" 
          }
        }
    else{
        // Add new contact with default status
        mergedContacts.push({ ...returnContact, status: "add" });
        // mergedContacts.push({ ...returnContact }); // add new
    } 



    return mergedContacts;
    // setSelectedContacts(mergedContacts);

  }



  function initializeAdd() {
    console.log("initializing add");
    setFormData(emptyForm);
    setSelectedContacts([]);
  }

  async function initializeEdit(id){
    //  console.log("initializing edit", id);
      try {
        setLoading(true);
        const res = await encryptedapiRequest.get(`/requirements/${id}`);
        if (!res.data) return;
        if (res.data?.status === "success" && res.data.data.length > 0) {
          const reqRes=res.data.data[0];

          const requirementcontacts = reqRes.clientcontactid
            ? [{ id: Number(reqRes.clientcontactid) }]
            : [];

          const colonies = JSON.parse(
            reqRes.colonies  || "[]"
          ).map(({ colonyname, ...rest }) => ({
            name: colonyname,  // changing colonyname to name
            ...rest
          }));

          const propertytags = reqRes.propertytags
          ? JSON.parse(reqRes.propertytags)
          : [];

          const propertytypes = reqRes.propertytypes
          ? JSON.parse(reqRes.propertytypes)
          : [];

          const transactiontypes=reqRes.transactiontypes
          ? JSON.parse(reqRes.transactiontypes)
          : [];


          setFormData({
            colonies:colonies,
            propertytags:propertytags,
            propertytypes:propertytypes,
            transactiontypes:transactiontypes,
            
            requirementcontacts:requirementcontacts,
            requirementdetails:reqRes.requirementdetails,
            budgetfrom:reqRes.budgetfrom,
            budgetto:reqRes.budgetto,
            requirementdate:reqRes.dateofrequirement,

          })

          // console.log("fetched contacts", requirementcontacts);
          setSelectedContacts(requirementcontacts);

        } else {
          setError("Requirement not found");
        }

      } catch (err) {
        console.error("Failed to load Requirement Details", err);
      } finally {
        setLoading(false);    
      }
  }

  
  
  
  // ===============================
  // SINGLE CLEAN EFFECT
  // ===============================

  const restoredRef = useRef(false);
  useEffect(() => {

    // 1️⃣ POP (Back navigation) → Restore Draft
    if (navType === "POP") {
        if (!restoredRef.current) {
          const restored = restoreDraft();
          restoredRef.current = true;
          console.log("restored draft:", restored);
          if (restored) return;
        }
      }
    // 2️⃣ Add Mode
    if (mode === 0) {
      console.log("add mode");
      initializeAdd();
      return;
    }

    // 3️⃣ Edit Mode
    if (mode === 1 && requirementId) {
      // console.log("editing")
      initializeEdit(requirementId);
    }

  }, [mode, requirementId, navType]);


  






    // console.log("requirementObject",requirementObject);
    // console.log("requirementId",requirementId);
    // console.log("userId",userId);

// // Fetch data once when the component mounts
// useEffect(() => {
//   const fetchRequirementData = async () => {
//     let fetchedData = null; // Declare outside try block
//     try {
//       if (mode===1){
//         const res = await encryptedapiRequest.get(`/requirements/${requirementId}`);
//         if (res.data?.status === "success" && res.data.data.length > 0) {
//           setRequirementData(res.data.data[0]);
//         } else {
//           setRequirementData(null);
//           setError("Requirement not found");
//         }
//       }
//       else{
//         setRequirementData(null)
//         setLoading(false)
//         setDataLoaded(true); // ✅ THIS IS WHAT YOU NEED
//       }

//     } catch (err) {
//       console.error("Error fetching Requirement data:", err);
//       setError("Failed to load Requirement data.");
//     } finally {
//       setLoading(false);
//     }
//   };
//   fetchRequirementData();
// }, []);


// // now to fill the form
// useEffect(() => {

//   if (!requirementData) return;

// const requirementcontacts = requirementData.clientcontactid
//   ? [{ id: Number(requirementData.clientcontactid) }]
//   : [];


//   const colonies = JSON.parse(
//     requirementData.colonies || requirementData.colonies || "[]"
//   ).map(({ colonyname, ...rest }) => ({
//     name: colonyname,
//     ...rest
//   }));

//   const propertytags = requirementData.propertytags
//   ? JSON.parse(requirementData.propertytags)
//   : [];

//   const propertytypes = requirementData.propertytypes
//   ? JSON.parse(requirementData.propertytypes)
//   : [];

//   const transactiontypes=requirementData.transactiontypes
//   ? JSON.parse(requirementData.transactiontypes)
//   : [];

//   setFormData({
//     requirementcontacts:requirementcontacts,
//     requirementdetails:requirementData.requirementdetails,
//     colonies:colonies,
//     propertytags:propertytags,
//     propertytypes:propertytypes,
//     transactiontypes:transactiontypes,
//     budgetfrom:requirementData.budgetfrom,
//     budgetto:requirementData.budgetto,
//     requirementdate:requirementData.dateofrequirement,

//   })

//   setSelectedContacts(requirementcontacts)
//   setDataLoaded(true); // ✅ mark as fully loaded

// }, [requirementData]);


  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };




    function BuildPayload(){
      if (!formData) return;

        let requirementObj=new Object;
        // form fields
        requirementObj.requirementdetails=formData.requirementdetails;
        requirementObj.budgetfrom=formData.budgetfrom;
        requirementObj.budgetto=formData.budgetto;  
        requirementObj.dateofrequirement=formData.requirementdate;
        requirementObj.requirementcontacts=selectedContacts;
        requirementObj.userid=userId;
        requirementObj.id=requirementId
        

        requirementObj.colonies=formData.colonies;

        requirementObj.coloniesToAdd = formData.colonies
          .filter(f => f.status === "add" && !('requirement_colonies_id' in f))
          .map(f => f.id);

        requirementObj.coloniesToDelete = formData.colonies
          .filter(f => f.status === "delete" && 'requirement_colonies_id' in f)
          .map(f => f.requirement_colonies_id);


        
        requirementObj.propertytags=formData.propertytags;
        requirementObj.propertytagsToAdd = formData.propertytags
          .filter(f => f.status === "add" && !('requirement_propertytag_id' in f))
          .map(f => f.id);

        requirementObj.propertytagsToDelete = formData.propertytags
          .filter(f => f.status === "delete" && 'requirement_propertytag_id' in f)
          .map(f => f.requirement_propertytag_id);  



        requirementObj.propertytypes=formData.propertytypes;
        requirementObj.propertytypesToAdd = formData.propertytypes
          .filter(f => f.status === "add" && !('requirement_propertytype_id' in f))
          .map(f => f.id);

        requirementObj.propertytypesToDelete = formData.propertytypes
          .filter(f => f.status === "delete" && 'requirement_propertytype_id' in f)
          .map(f => f.requirement_propertytype_id);


        requirementObj.transactiontypes=formData.transactiontypes;
        requirementObj.transactiontypesToAdd = formData.transactiontypes
          .filter(f => f.status === "add" && !('requirement_transactiontype_id' in f))
          .map(f => f.id);

        requirementObj.transactiontypesToDelete = formData.transactiontypes
          .filter(f => f.status === "delete" && 'requirement_transactiontype_id' in f)
          .map(f => f.requirement_transactiontype_id);
                                
          requirementObj.requirementcontacts =selectedContacts
            .filter(f => f.status !== "delete")
            .map(f => ({ id: f.id }));


        // console.log("requirementObj in buildpayload: ",requirementObj);

        const payload = new FormData();
        payload.append("requirement",JSON.stringify(requirementObj))
        

    return payload;

  }



function validateRequirement(formData) {
  const errors = {};

  // console.log("validating")
  if (!formData.requirementdetails?.trim()) {
    errors.requirementdetails = "Requirement details are required";
  }

  // console.log("Selected Contacts: ",selectedContacts);
  if (!Array.isArray(selectedContacts) || selectedContacts.length < 1) {
    console.log("formData.requirementcontacts: ",selectedContacts);
    errors.requirementcontacts = "At least one contact is required";
  }

  if (!Array.isArray(formData.transactiontypes) || formData.transactiontypes.length < 1) {
    errors.transactiontypes = "At least one transaction type is required";
  }

  if (Number(formData.budgetfrom) <= 0) {
    errors.budgetfrom = "Budget from must be greater than 0";
  }

  if (
    Number(formData.budgetto) > 0 &&
    Number(formData.budgetfrom) > Number(formData.budgetto)
  ) {
    errors.budgetto = "Budget to must be greater than budget from";
  }

  return errors;
}


// useEffect(() => {
//   const newContact = consumePendingContact();

//   if (!newContact) return;

//     console.log("New Contact received",newContact)

//   const interval = setInterval(() => {
//     if (tagrefContactSelect.current?.getAllContacts()?.length > 0) {
//       tagrefContactSelect.current.addNewContact(newContact);
//       clearInterval(interval);
//     }
//   }, 50);

//   return () => clearInterval(interval);

//   // setSelectedContacts(prev => prev.some(c => c.id === newContact.id) ? prev : [...prev, { ...newContact, status: "add" }]);

// }, []);







  const handleSave = async (e) => {
    e.preventDefault();
    let res;

      const errors = validateRequirement(formData);

      if (Object.keys(errors).length > 0) {
        console.warn("Validation failed:", errors);
        setError(errors); // optional state for UI


        // Clear errors after 5 seconds
            setTimeout(() => {
              setError({});
            }, 10000);

        return;
      }



    try {
      const payload=BuildPayload();

      if (mode===0){
        // adding

        res = await apiRequest.post(`/requirements/`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

      }
      else{
        // updating
        res = await apiRequest.post(`/requirements/update/`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }


        // SAVING 



    
      if (res?.data?.status === "success") {
        // Navigate back one page
        // saving requirement object
        saveObjectDraft({
          action:mode===0 ?'add':'update',
          returnData:res?.data?.data[0],
          // returnData,
          // content,
          // images,
          // selectedContacts,
        });



        navigate(-1);
      } else {
        console.error("Save failed:", res?.data?.message);
      }


    } catch (err) {
      console.log(err);
    }

  }





// console.log("selectedContacts",selectedContacts);
// console.log("formData",formData);



  // const handleCancel = async (e) => {
  //   e.preventDefault();
  //   navigate(-1);
  // }



  const handleCheckContacts = async (e) => {
    e.preventDefault();
    // console.log("formDate: ",formData);
 
    // console.log("AllContacts: ",tagrefContactSelect.current.getAllContacts());  
    // console.log("AllSelectedContacts: ",tagrefContactSelect.current.getAllSelectedContacts());

    



  }



const handleAddNewContact = (e) => {
  e.preventDefault();
  console.log("saving post on add new contact")
  saveObjectDraft({
    formData,
    selectedContacts,
  
  });
  navigate('/dashboard/savecontact/', {
    state: {
      mode: 0,
      clientcontact: null,
      clientcontactid: 0,
      clientid: currentUser?.clientid
    }
  });


  // e.preventDefault();
  //   navigate('/dashboard/savecontact/', {
  //     state: {
  //       mode: 0,
  //       clientcontact: null,
  //       clientcontactid: 0,
  //       clientid: currentUser?.clientid
  //     }
  //   });


  };

const onSelectedContactClick = (contact) => {

  // e.preventDefault();
  // setShowAddColonyModal(true)
console.log("saving post on click: ",contact);
if (!contact?.id) return;

  saveObjectDraft({
    formData,
    selectedContacts,
    // postObject,
  });

  navigate("/dashboard/savecontact/", {
    state: {
      mode: 1, // edit mode
      clientcontact: contact,
      clientcontactid: contact.id,
      clientid: currentUser?.clientid
    }
  });

  };






  if (loading) return <p>Loading Requirements data...</p>;
  // if (error) return <p style={{ color: "red" }}>{Object.entries(error).map(([key, message]) => (
  //   <p key={key}>{message}</p>
  // ))}</p>;


  if (!formData) return <p>Loading form...</p>; // Prevents errors if formData is null



  return (
    <>
    <div className="SaveRequirementPage">
        <div className="PageHeader">
            <DashboardHeader title={mode===0?"Add Requirement":"Save Requirement"} toggleMenu={toggleMenu} />
        </div>
        <div className="PageContent">
              <form className="formGrid">

                <div className="FormContainer">

                  {/* details */}
                  <div className="FormRow">
                      <label>Details</label>

                      <div className="inputCol details">

                          <input 
                            type="text" 
                            placeholder="Enter requirement details" 
                            name="requirementdetails"
                            value={formData.requirementdetails}
                            onChange={handleChange}
                          />

                            {error?.requirementdetails && <p className="errorText">{error.requirementdetails}</p>}

                      </div>
                  </div>


                   {/* requirement by */}
                  <div className="FormRow">
                      <label>Requirement By</label>

                      <div className="inputCol">
                          {currentUser?.clientid && (
                          


                            <ContactSearchSelectAdd 
                                ref={tagrefContactSelect}

                                limitSelected={1}
                                
                                selectedContacts={selectedContacts}
                                setSelectedContacts={setSelectedContacts}

                                onSelectedContactClick={onSelectedContactClick}
                                onAddNew={handleAddNewContact}
                                clientId={currentUser.clientid} 
                            />


                          )}


                          {error?.requirementcontacts && <p className="errorText">{error.requirementcontacts}</p>}

                      </div>
                  </div>




                  {/* transaction types */}
                  <div className="FormRow">
                      <label>Transaction Type</label>

                      <div className="inputCol">
                          <Comp_TransactionType
                              // ref={tagrefTransType}
                              controlType = {2}

                              // defaultTags={formData.transactiontypes}
                              selectedTags={formData.transactiontypes}
                              setSelectedTags={(tags) => setFormData(prev => ({ ...prev, transactiontypes: tags }))}
                          >

                          </Comp_TransactionType>

                          {error?.transactiontypes && <p className="errorText">{error.transactiontypes}</p>}
                        </div>
                  </div>

                

                  {/* property types */}
                  <div className="FormRow">
                      <label>Property Type</label>
                      {/* {console.log("formData.propertytypes",formData.propertytypes  )} */}
                      <div className="inputCol">
                            <Comp_PropertyType
                              // ref={tagrefPropertyType}

                              selectedTags={formData.propertytypes}
                              setSelectedTags={(tags) => setFormData(prev => ({ ...prev, propertytypes: tags }))}
                              >                              
                            </Comp_PropertyType>
                      </div>


                  </div>

                  {/* colony interests */}
                  <div className="FormRow">
                      <label>Colony Interests</label>

                      <div className="inputCol">
                          <Comp_Colonies
                            // style={{ width: "100%" }}
                            // maxTags={1}
                            // ref={tagrefColonies}
                            // displayKey="colonyname"
                            // parentKey='colonyaddress'
                            // defaultTags={formData.colonies}
                            selectedTags={formData.colonies}
                            setSelectedTags={(tags) => setFormData(prev => ({ ...prev, colonies: tags }))}  
                            // onColonyChangeTag={handleColonyChange}
                          />

                      </div>

                  </div>

                   {/* budget */}
                  {/* <div className="FormRow">
                      <label>Budget</label>

                      <div className="inputCol">
                            <input 
                              type="number" 
                              placeholder="From" 
                              name="budgetfrom"
                              value={formData.budgetfrom}
                              onChange={handleChange}
                            />
                            :
                            <input 
                              type="number" 
                              placeholder="To" 
                              name="budgetto"
                              value={formData.budgetto}
                              onChange={handleChange}
                            />
                       </div>
                      <div>{formatToIndianRupees( formData.budgetfrom)}</div>
                      <div>{formatToIndianRupees( formData.budgetto)} </div>

                  </div>
 */}




<div className="FormRow">
  <label>Budget</label>

  <div className="inputCol">
    <div className="budgetCol">
      <input
        type="number"
        placeholder="From"
        name="budgetfrom"
        value={formData.budgetfrom}
        onChange={handleChange}
      />
      <div className="formatted">
        ₹ {formatToIndianRupees(formData.budgetfrom)}
      </div>

      {error?.budgetfrom && <p className="errorText">{error.budgetfrom}</p>}

    </div>

    <span className="separator">:</span>

    <div className="budgetCol">
      <input
        type="number"
        placeholder="To"
        // name="budgetto"
        name="budgetto"

        value={formData.budgetto}
        onChange={handleChange}
      />
      <div className="formatted">
        ₹ {formatToIndianRupees(formData.budgetto)}
      </div>

      {error?.budgetto && <p className="errorText">{error.budgetto}</p>}

    </div>
  </div>
</div>



                   {/* Property Tags */}
                  <div className="FormRow">
                      <label>Preference</label>
                      <div className="inputCol">
                        <Comp_GeneralFeatures
                          // ref={tagrefGeneral}
                          selectedTags={formData.propertytags}
                          setSelectedTags={(tags) => setFormData(prev => ({ ...prev, propertytags: tags }))}                          
                        >
                        </Comp_GeneralFeatures>
                      </div>
                  </div>

                </div>

                {error && typeof error === "object" && Object.keys(error).length > 0 && (
                  <div className="formErrors">
                    {Object.values(error).map((errMsg, index) => (
                      <p key={index} className="errorText">{errMsg}</p>
                    ))}
                  </div>
                )}




                {/* formcontainter */}
              </form>
        </div>

        <div className="errorContainer">

            {error && typeof error === "object" && Object.keys(error).length > 0 && (
              <div className="formErrors">
                {Object.entries(error).map(([key, message]) => (
                  <p key={key} className="errorText">{message}</p>
                ))}
              </div>
            )}

        </div>


        <div className="buttonContainer">

          <button onClick={handleSave}>Save</button>
          {/* <button onClick={handleCancel}>Cancel</button> */}
          <CancelButton></CancelButton>                

          {/* <button onClick={handleCheckContacts}>check contacts</button> */}


        </div>



    </div>
    
    </>
  )
}

export default SaveRequirement
